import JointVentureIcon from "@src/assets/icons/handshake.svg";
import UserIcon from "@src/assets/icons/profile.svg";
import { REQUEST_STATUS } from "@src/constants";
import { Tooltip } from "antd";
import "./status.less";

interface StatusProps {
  status: string; // can also be outdated here
  assignedEmployeeFullName?: string;
  isJointVentureRequest?: boolean;
  jointVenturePartner?: string;
}

const Status: React.FC<StatusProps> = ({
  status,
  assignedEmployeeFullName,
  isJointVentureRequest,
  jointVenturePartner,
}) => {
  function formatStatusClassName(status: string) {
    return status?.toLowerCase()?.replace(" ", "-");
  }

  return (
    <div className="status">
      <div className="status-text">
        <div
          data-testid="status-icon"
          className={
            "status-icon " + `status-icon-${formatStatusClassName(status)}`
          }
        />
        <div>{status}</div>
      </div>
      {assignedEmployeeFullName && status !== REQUEST_STATUS.REQUESTED && (
        <Tooltip placement="topLeft" title={assignedEmployeeFullName}>
          <div className="status-subtext" data-testid="status-subtext">
            <UserIcon className="status-profile-icon" />
            <span>{assignedEmployeeFullName}</span>
          </div>
        </Tooltip>
      )}
      {isJointVentureRequest && status === REQUEST_STATUS.CONFIRMED && (
        <Tooltip placement="topLeft" title={jointVenturePartner}>
          <div className="status-subtext" data-testid="status-subtext">
            <JointVentureIcon
              className="status-jv-icon"
              data-testid="joint-venture-icon"
            />
            <span>{jointVenturePartner}</span>
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default Status;
